export const computeReliabilityScore = (params) => {
  const { worked, callouts, decommits } = params;
  const allCommittedShifts = worked + callouts + decommits;
  const reliabilityScore = !!worked
    ? ((worked / allCommittedShifts) * 100).toFixed(2)
    : 'rookie';
  return reliabilityScore;
};
